function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 0c6.629 0 12 5.373 12 11.998C24 18.626 18.629 24 12 24 5.373 24 0 18.626 0 11.998 0 5.372 5.373 0 12 0zm-.001 7.278c-2.607 0-4.721 2.113-4.721 4.72 0 2.61 2.114 4.723 4.72 4.723 2.61 0 4.722-2.113 4.722-4.722 0-2.608-2.112-4.72-4.721-4.72zm0 .722C14.206 8 16 9.795 16 12c0 2.206-1.795 4-4 4-2.206 0-4-1.794-4-4 0-2.205 1.793-4 4-4zm0 .462c-1.95 0-3.538 1.587-3.538 3.54 0 1.95 1.587 3.537 3.539 3.537 1.952 0 3.539-1.587 3.539-3.538 0-1.952-1.587-3.54-3.54-3.54zM12 10c1.104 0 2.001.897 2.001 2 0 1.102-.897 2-2 2s-2-.898-2-2c0-1.102.897-2 2-2zm0 .483c-.836 0-1.517.68-1.517 1.517 0 .837.68 1.517 1.518 1.517.836 0 1.518-.68 1.518-1.517 0-.837-.682-1.517-1.518-1.517zm1.636-9.153c-.205-.036-.413-.037-.618-.003-1.003.165-1.682 1.113-1.516 2.116l.514 3.115s.514-.05 1.002.197l1.779-2.79c.122-.192.206-.407.245-.632.165-.941-.465-1.838-1.406-2.003z"
});

var SvgMaster = function SvgMaster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#c4c4c4",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/master.45031ae1.svg";
export { ForwardRef as ReactComponent };